import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=849cc20e"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849cc20e')) {
      api.createRecord('849cc20e', component.options)
    } else {
      api.reload('849cc20e', component.options)
    }
    module.hot.accept("./MenuList.vue?vue&type=template&id=849cc20e", function () {
      api.rerender('849cc20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/menu/MenuList.vue"
export default component.exports